module.exports = __webpack_public_path__ + "close-media.svg?a9c0f3a6f30246509d8b85d2c1ad3b8d";